import { Box, Button, Container, Grid, Paper } from "@mui/material"
import React, { useEffect, useRef, useState } from "react"
import BarcodeList, { BarcodeOriginal } from "../components/Reactbarcode"
import CenterModal from "../components/Modal"
import { toast } from "react-toastify"
import apiClient from "../api/apiClient"
import CircularProgress from "@mui/material/CircularProgress"
import Paginate from "../components/mui/Paginate"
import { Helmet } from "react-helmet"
import jsPDF from "jspdf"
import JSZip from "jszip"
import { saveAs } from "file-saver"
import html2canvas from "html2canvas"
import html2pdf from "html2pdf.js"
import TabBars from "../components/mui/TabBars"
import PropTypes from "prop-types"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Typography from "@mui/material/Typography"
import SelectOption from "../components/mui/SelectOption"
import LoadingOverlay from "../components/mui/LoadingOverlay"
import { BarcodeFilterSidebar } from "../components/sidebar-filter/ProductFilterSidebar"
import { objectToQueryString } from "../modules/helpers"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import BarcodeListArchive from "../components/BarcodeArchive"
import { useSearchParams } from "react-router-dom"

let limit = 12
export default function ArchiveBarcode() {
  return (
    <div>
      <div className="d-flex justify-content-center">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}></Box>
      </div>

      <ArchiveTab />
    </div>
  )
}

function ArchiveTab() {
  const [searchParams, setSearchParams] = useSearchParams()
  const urlPage = parseInt(searchParams.get("page")) || 1
  const [count, setCount] = useState(0)
  const [load, setLoad] = useState(false)
  const [barcodeValues, setBarcodeValues] = useState()
  const [page, setPage] = useState(urlPage)
  const [barcodeType, setType] = useState(searchParams.get("key") || "")
  const [showFilter, setShowFilter] = useState(false)
  const [date, setDate] = useState([])
  const [reset, setReset] = useState(false)
  const intialFilters = {
    barcode: searchParams.get("barcode") || "",
    status: searchParams.get("status") || "",
    code_disabled:""
  }
  const [filters, setFilters] = useState(intialFilters)
  const onReset = () => {
    setFilters({ barcode: "", status: "", code_disabled: "" })
    setPage(1)
    setSearchParams({})
    setReset(true)
  }
  const onFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value })
  }
  useEffect(() => {
    if (reset) fetchdata()
  }, [reset])
  useEffect(() => {
    fetchdata(page)
  }, [barcodeType])

  const fetchdata = async (currentPage = page) => {
    if (currentPage == 1 && count) setCount(0)
    setLoad(true)


       const filtersObj = buildFiltersObj(filters)
    const params = new URLSearchParams()
    if (barcodeType) params.set("key", barcodeType)
    if (filters.barcode) params.set("barcode", filters.barcode)
    if (filters.status) params.set("status", filters.status)
    if (currentPage > 1) params.set("page", currentPage)
    setSearchParams(params)
    setPage(currentPage)

    const result = await apiClient.get(
      `/qr/?limit=${limit}&page=${currentPage}&archive=true&key=${barcodeType}&${objectToQueryString(
        filtersObj
      )}`
    )
    setLoad(false)
    if (!result.ok) return toast.error("Error")
    if (!count || currentPage == 1 || count !== result.data.count) setCount(result.data.count)
    //console.log(result.data,"lllllll");
    setBarcodeValues(result.data.results)
  }



    function buildFiltersObj(filters) {
  const { status, ...rest } = filters;
  switch (status) {
    case "disabled":
      return { ...rest, code_disabled: true, activated: "" };
    case "activated":
      return { ...rest, activated: true, code_disabled: false };
    case "not-activated":
      return { ...rest, activated: false, code_disabled: false };
    default:
      return { ...rest, activated: "", code_disabled: "" };
  }
}
  const handlePageChange = (event, value) => {
    fetchdata(value)
  }

  const baseUrl = "www.gphtest.com"

  return (
    <div>
      <Helmet>
        <title>Barcode</title>
      </Helmet>
      <Container className="" maxWidth="lg">
        <BarcodeFilterSidebar
          openFilter={showFilter}
          onOpenFilter={() => setShowFilter(true)}
          onCloseFilter={() => setShowFilter(false)}
          handleChange={onFilterChange}
          values={filters}
          onReset={onReset}
          fetchData={() => fetchdata(1)}
        />
        {load ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : (
          <div className="d-flex justify-content-center ">
            <Grid
              md={9}
              xs={12}
              container
              className="shadow"
              sx={{ marginTop: 5, borderRadius: 10 }}>
              <Grid className="p-3 row justify-content-end" item xs={12}>
                <div className="col-4">
                  <SelectOption
                    style={{ width: "100%" }}
                    size="small"
                    data={[
                      { value: "!pp", label: "Normal" },
                      { value: "pp", label: "PP Barcodes" },
                      { value: "exp", label: "EXP Barcodes" }
                    ]}
                    id="outlined-basic"
                    value={barcodeType}
                    onChange={e => {
                      setPage(1)
                      setType(e.target.value)
                      console.log(e.target.value)
                    }}
                    label="Barcode Type"
                    variant="outlined"
                  />
                </div>
              </Grid>

              {barcodeValues?.map(value => (
                <Grid
                  className=""
                  item
                  md={4}
                  sm={6}
                  xs={12}
                  spacing={5}
                  sx={{ marginTop: 3, padding: 2 }}>
                  <BarcodeListArchive url={baseUrl} value={value} ShowiIcon={true} />
                </Grid>
              ))}
            </Grid>
          </div>
        )}
        <div className={`${load && "d-none "}   d-flex justify-content-center `}>
          <Paginate
            className="btn_bg"
            color="primary"
            style={{ color: "white" }}
            count={count}
            limit={limit}
            page={page}
            onChange={handlePageChange}
          />
        </div>
      </Container>
    </div>
  )
}
